import { Component, Input } from '@angular/core';
import { ModalComponent } from '@appShared/components/modal/modal.component';
import { IPlan, IShareholder } from '@appShared/interfaces/[Model-based]';
import { ShareholderPlanEditComponent } from './shareholder-plan-edit.component';

@Component({
  template: `
    <app-modal title="Stock Plan ({{shareholder?.firstName}} {{shareholder?.lastName}})" [showFooter]="false">
      <app-shareholder-plan-edit
        [shareholder]="shareholder"
        [plan]="plan"
        [canEdit]="canEdit"
        (shareholderUpdated)="refreshGrid()">
      </app-shareholder-plan-edit>
    </app-modal>`,
   imports: [ModalComponent, ShareholderPlanEditComponent]
})
export class ShareholderPlanEditModalComponent {
  @Input() shareholder: IShareholder;
  @Input() plan: IPlan;
  @Input() canEdit: boolean;
  @Input() refreshGrid: () => void;

  constructor() {}
}
